import { create } from 'zustand'

interface AppState {
  menuOpen: boolean
  setMenuOpen: (val: boolean) => void
  accountModal: boolean
  setAccountModal: (val: boolean) => void
  cartState: 'closed' | 'expanded' | 'open'
  setCartState: (val: 'closed' | 'expanded' | 'open') => void
  notifyId: string | null
  setNotifyId: (val: string | null) => void
}

export const useAppStore = create<AppState>((set) => ({
  menuOpen: false,
  setMenuOpen: (open) => set({ menuOpen: open }),
  accountModal: false,
  setAccountModal: (open) => set({ accountModal: open }),
  cartState: 'closed',
  setCartState: (cartState) => set({ cartState }),
  notifyId: null,
  setNotifyId: (notifyId) => set({ notifyId }),
}))
